/**
 * Rich-text answers (e.g. Quill) can be truthy strings like "<p><br></p>" that look empty.
 * Use this instead of Boolean(a) when building MCQ option lists for the preview.
 */
export function answerHasRenderableContent(raw: unknown): boolean {
  const s = String(raw ?? "").trim();
  if (!s) return false;
  if (/\.(mp3|png|jpe?g|gif|webp|mp4|mkv|avi|ogg)(\?|#|$)/i.test(s)) {
    return true;
  }
  const withoutTags = s.replace(/<[^>]*>/g, " ");
  const text = withoutTags
    .replace(/&nbsp;/gi, " ")
    .replace(/&#\d+;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return text.length > 0;
}
